import api from "./client";
export async function getLegalDocs() {
    const res = await api.get("/admin/legal");
    return res.data;
}
export async function getLegalDoc(id) {
    const res = await api.get(`/admin/legal/${id}`);
    return res.data;
}
export async function upsertLegalDoc(data) {
    const res = await api.post("/admin/legal", data);
    return res.data;
}
export async function updateLegalDoc(id, data) {
    const res = await api.put(`/admin/legal/${id}`, data);
    return res.data;
}
export async function deleteLegalDoc(id) {
    await api.delete(`/admin/legal/${id}`);
}
export async function getValidSlugs() {
    const res = await api.get("/admin/legal/slugs");
    return res.data;
}
